import { useIsServerSideRendering } from '@dbh/environment';

const LoadingPlaceholder=a=>{const b=useIsServerSideRendering();if(b)return null;const{children:c}=a;return c||null};LoadingPlaceholder.displayName="LoadingPlaceholder";

export { LoadingPlaceholder as default };
